import { UseFormReturn } from "react-hook-form";
import { useGoal } from "@pages/Program/components/goal/utils/useGoal";
import { GoalPayload } from "@shared/interfaces/ProgramFiles";

interface SaveGoalOptions {
  goalId?: string;
}

const useHandleSaveGoal = (
  options: SaveGoalOptions,
  methods: UseFormReturn<any>
) => {
  const { saveGoal } = useGoal();

  const handleSaveGoal = async (payload: GoalPayload) => {
    try {
      await saveGoal(payload, { goalId: options.goalId });

      methods.reset();
    } catch (error) {
      console.error("Error saving goal:", error);
    }
  };

  return handleSaveGoal;
};

export default useHandleSaveGoal;
